/* eslint-disable no-param-reassign */

import { ADWORDS_API_VERSIONS } from '../../../../../../../app/constants/adwords_api_versions';

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerGoogleAdwordsSourceComponent', [
    '$rootScope',
    'DesignerBaseSourceAndDestinationComponent',

    function ($rootScope, DesignerBaseSourceAndDestinationComponent) {
      function DesignerGoogleAdwordsSourceComponent() {
        this.cloud_storage_connection_id = null;

        this.api_version = null;
        this.report_type = null;
        this.customer_ids = null;
        this.customer_id_field_alias = null;

        this.report_date_range_type = null;
        this.report_date_range_min = null;
        this.report_date_range_max = null;

        DesignerBaseSourceAndDestinationComponent.apply(this);
      }

      DesignerGoogleAdwordsSourceComponent.prototype = new DesignerBaseSourceAndDestinationComponent();

      DesignerGoogleAdwordsSourceComponent.prototype.getData = function () {
        const data = DesignerBaseSourceAndDestinationComponent.prototype.getData.call(this);

        _.extend(data, {
          cloud_storage_connection_id: String(this.connection.id || ''),
          api_version: this.api_version || ADWORDS_API_VERSIONS[0].value,
          report_type: this.report_type || this.defaults.report_type,
          customer_ids: this.customer_ids || this.defaults.customer_ids,
          customer_id_field_alias: this.customer_id_field_alias || this.defaults.customer_id_field_alias,
          report_date_range_type:
            this.report_date_range_type != null ? this.report_date_range_type : this.defaults.report_date_range_type,
          report_date_range_min: this.report_date_range_min || this.defaults.report_date_range_min,
          report_date_range_max: this.report_date_range_max || this.defaults.report_date_range_max,
          report_date_range_field: this.report_date_range_field || this.defaults.report_date_range_field,
          report_on: this.report_on || this.defaults.report_on,
        });

        return data;
      };

      DesignerGoogleAdwordsSourceComponent.prototype.setFormData = function (data) {
        const customersIdIndex = _.findIndex(data.schema.fields, { name: 'customer_id' });

        if (customersIdIndex > -1) {
          data.customer_id_field_alias = data.schema.fields[customersIdIndex].alias;
          data.schema.fields.splice(customersIdIndex, 1);
        }

        this.setData(data);

        DesignerBaseSourceAndDestinationComponent.prototype.setFormData.call(this, data);
      };

      DesignerGoogleAdwordsSourceComponent.prototype.setData = function (data) {
        this.cloud_storage_connection_id = String(this.connection.id || '');
        this.api_version = data.api_version;
        this.report_type = data.report_type;
        this.report_date_range_type = data.report_date_range_type;
        this.report_date_range_min = data.report_date_range_min;
        this.report_date_range_max = data.report_date_range_max;
        this.customer_id_field_alias = data.customer_id_field_alias;
        this.customer_ids = data.customer_ids;
        this.report_date_range_field = data.report_date_range_field || '';

        this.report_on = data.report_on;
        if (!this.report_on) {
          if (!this.customer_ids) this.report_on = 'all';
          else if (this.customer_ids.charAt(0) === '$') this.report_on = 'custom';
          else this.report_on = 'specific';
        }

        if (this.report_on === 'all') {
          this.customer_ids = '';
        }

        DesignerBaseSourceAndDestinationComponent.prototype.setData.call(this, data);
      };

      DesignerGoogleAdwordsSourceComponent.prototype.getSchema = function () {
        const schema = DesignerBaseSourceAndDestinationComponent.prototype.getSchema.call(this);

        if (this.customer_id_field_alias && this.customer_id_field_alias.length > 0) {
          schema.fields.unshift({
            name: this.customer_id_field_alias,
          });
        }

        return schema;
      };

      return DesignerGoogleAdwordsSourceComponent;
    },
  ]);
})(window.angular);
